export var HttpRequestUtil;
(function (HttpRequestUtil) {
    let StatusCode;
    (function (StatusCode) {
        // 成功
        StatusCode[StatusCode["Ok"] = 200] = "Ok";
        StatusCode[StatusCode["Created"] = 201] = "Created";
        StatusCode[StatusCode["NotModified"] = 304] = "NotModified";
        // エラー(クライアント側の問題)
        StatusCode[StatusCode["BadRequest"] = 400] = "BadRequest";
        StatusCode[StatusCode["UnAuthorized"] = 401] = "UnAuthorized";
        StatusCode[StatusCode["Forbidden"] = 403] = "Forbidden";
        StatusCode[StatusCode["NotFound"] = 404] = "NotFound";
        StatusCode[StatusCode["Conflict"] = 409] = "Conflict";
        StatusCode[StatusCode["TooManyRequests"] = 429] = "TooManyRequests";
        // エラー(サーバー側の問題)
        StatusCode[StatusCode["InternalServerError"] = 500] = "InternalServerError";
        StatusCode[StatusCode["BadGateway"] = 502] = "BadGateway";
        StatusCode[StatusCode["ServiceUnavailable"] = 503] = "ServiceUnavailable";
        StatusCode[StatusCode["GatewayTimeout"] = 504] = "GatewayTimeout";
    })(StatusCode || (StatusCode = {}));
    /**
     * メッセージを表示するタイプ
     */
    let DisplayMessageType;
    (function (DisplayMessageType) {
        DisplayMessageType[DisplayMessageType["None"] = 0] = "None";
        DisplayMessageType[DisplayMessageType["ErrorOnly"] = 1] = "ErrorOnly";
        DisplayMessageType[DisplayMessageType["All"] = 2] = "All";
    })(DisplayMessageType = HttpRequestUtil.DisplayMessageType || (HttpRequestUtil.DisplayMessageType = {}));
    /**
     * Http のメソッドの種類(使用するもののみ)
     */
    let MethodType;
    (function (MethodType) {
        MethodType["Get"] = "GET";
        MethodType["Post"] = "POST";
        MethodType["Put"] = "PUT";
        MethodType["Delete"] = "DELETE";
    })(MethodType || (MethodType = {}));
    /**
     * 戻る情報のタイプ
     */
    let ResponseType;
    (function (ResponseType) {
        ResponseType["Json"] = "json";
        ResponseType["Text"] = "text";
    })(ResponseType = HttpRequestUtil.ResponseType || (HttpRequestUtil.ResponseType = {}));
    class Option {
        constructor() {
            this.responseType = ResponseType.Json;
            this.progressMessage = null;
            this.errorCallback = (response) => {
            };
            this.finishCallback = (response) => {
            };
            this.signalId = null; // 一意なシグナルIDを指定すると、多重リクエスト時に前のリクエストをキャンセルされる
            this.displayMessageType = DisplayMessageType.All;
            // 外から呼び出せないようにする
        }
        static createForGet() {
            const option = new Option();
            option.displayMessageType = DisplayMessageType.ErrorOnly;
            return option;
        }
        static createForPost() {
            const option = new Option();
            option.progressMessage = setting.defaultPostProgressMessage;
            return option;
        }
        static createForDelete() {
            const option = new Option();
            option.progressMessage = setting.defaultDeleteProgressMessage;
            return option;
        }
        static createForPut() {
            return new Option();
        }
    }
    HttpRequestUtil.Option = Option;
    class Setting {
        constructor() {
            this.defaultPostProgressMessage = null;
            this.defaultDeleteProgressMessage = null;
            this.responseNotModifiedActionFunction = emptyFunction;
            this.responseUnAuthorizedActionFunction = emptyFunction;
            this.responseForbiddenActionFunction = emptyFunction;
            this.responseServiceUnavailableActionFunction = emptyFunction;
        }
    }
    HttpRequestUtil.Setting = Setting;
    const emptyFunction = () => {
    };
    let setting = new Setting();
    function setSettings(newSetting) {
        setting = newSetting;
    }
    HttpRequestUtil.setSettings = setSettings;
    const abortControllerMap = {};
    /**
     * HttpリクエストのGET
     * @param url
     * @param successCallback
     * @param option
     */
    function getRequest(url, successCallback, option = Option.createForGet()) {
        request(url, MethodType.Get, null, successCallback, option);
    }
    HttpRequestUtil.getRequest = getRequest;
    function postRequest(url, body, successCallback, option = Option.createForPost()) {
        request(url, MethodType.Post, body, successCallback, option);
    }
    HttpRequestUtil.postRequest = postRequest;
    function deleteRequest(url, body, successCallback, option = Option.createForDelete()) {
        request(url, MethodType.Delete, body, successCallback, option);
    }
    HttpRequestUtil.deleteRequest = deleteRequest;
    function putRequest(url, body, successCallback, option = Option.createForDelete()) {
        request(url, MethodType.Put, body, successCallback, option);
    }
    HttpRequestUtil.putRequest = putRequest;
    /**
     * すべてのリクエスト処理
     * @param url
     * @param method
     * @param body
     * @param successCallback
     * @param option
     * @private
     */
    function request(url, method, body, successCallback, option) {
        const displayMessageType = option.displayMessageType;
        const signalId = option.signalId;
        if (signalId != null) {
            // 同地 signalId で既に実行されているリクエストがあるか
            if (signalId in abortControllerMap) {
                const abortController = abortControllerMap[signalId];
                abortController.abort();
            }
        }
        // options の情報を取得
        const progressMessage = option.progressMessage;
        const errorCallback = option.errorCallback;
        const finishCallback = option.finishCallback;
        const responseType = option.responseType;
        const settingMap = {};
        settingMap["method"] = method;
        if (body !== null) {
            if (Object.prototype.toString.call(body) === '[object FormData]') {
                // ファイルなどを含む FormData の場合
                settingMap['body'] = body;
            }
            else {
                // 通常のパラメータの場合
                settingMap["headers"] = {
                    "Content-Type": "application/json; charset=utf-8",
                };
                const json = JSON.stringify(body);
                settingMap["body"] = json;
            }
        }
        if (displayMessageType === DisplayMessageType.All) {
            // すべてのメッセージを表示する場合、進捗メッセージを表示
            if (progressMessage != null) {
                if (setting.progressMessageAction != null) {
                    // 進捗メッセージを設定
                    setting.progressMessageAction(progressMessage);
                }
            }
        }
        if (signalId != null) {
            // 中断するための AbortController を作成
            const abortController = new AbortController();
            const fetchSignal = abortController.signal;
            settingMap['signal'] = fetchSignal;
            abortControllerMap[signalId] = abortController;
        }
        fetch(url, settingMap).then(response => {
            // signalId が指定されている場合、abortController を削除
            if (signalId != null) {
                delete abortControllerMap[signalId];
            }
            if (displayMessageType === DisplayMessageType.All) {
                // すべてのメッセージを表示する場合、進捗メッセージをクリア
                if (progressMessage != null) {
                    if (setting.progressMessageAction != null) {
                        // 進捗メッセージをクリア
                        setting.progressMessageAction('');
                    }
                }
            }
            const statusCode = response['status'];
            // bodyが返ってこないステータスコードの場合、先にチェック
            if (statusCode === StatusCode.NotModified) {
                if (displayMessageType === DisplayMessageType.All) {
                    setting.responseNotModifiedActionFunction();
                }
                return;
            }
            else if (statusCode === StatusCode.ServiceUnavailable) {
                // サービスがメンテナンス中
                setting.responseServiceUnavailableActionFunction();
                return;
            }
            else if (statusCode === StatusCode.TooManyRequests) {
                // 大量リクエストがきた場合
                return;
            }
            else if (statusCode === StatusCode.GatewayTimeout) {
                return;
            }
            else if (statusCode === StatusCode.BadGateway) {
                return;
            }
            const finishCallbackWithUpdateStatus = (response) => {
                finishCallback(response);
                // // ローディング状態を解除
                // setIsLoading(vue, false);
                // // ロード済状態に設定
                // setIsLoaded(vue);
            };
            if (progressMessage != null) {
                if (setting.finishProgressMessageAction != null) {
                    // 基本の終了時アクションを実行
                    setting.finishProgressMessageAction();
                }
            }
            // レスポンスタイプによって、関数を呼び分ける
            switch (responseType) {
                case ResponseType.Json:
                    processJson(response, successCallback, errorCallback, finishCallbackWithUpdateStatus, displayMessageType);
                    break;
                case ResponseType.Text:
                    processText(response, successCallback, errorCallback, finishCallbackWithUpdateStatus, displayMessageType);
                    break;
            }
        }).catch((error) => {
            if (error.toString() === 'AbortError: The user aborted a request.') {
                // HttpRequest が必要に応じてキャンセルされただけの場合はエラーを表示しない
                return;
            }
            console.error('Http Request Failed', error);
        });
    }
    // /**
    //  * ローディング状態を変更
    //  * @param vue
    //  * @param isLoading
    //  * @private
    //  */
    // function setIsLoading(vue: Vue, isLoading: boolean) {
    //     if (typeof vue.$data.isLoading !== 'undefined') {
    //         vue.$data.isLoading = isLoading;
    //     }
    // }
    //
    // /**
    //  * ロード済状態を true に設定
    //  * ※ false に戻ることは基本的にない
    //  * @param vue
    //  * @private
    //  */
    // function setIsLoaded(vue: Vue) {
    //     if (typeof vue.$data.isLoaded !== 'undefined') {
    //         if (!vue.$data.isLoaded) {
    //             vue.$data.isLoaded = true;
    //         }
    //     }
    // }
    /**
     * テキストが返ってくる場合の処理
     * ※未完成
     * @param response
     * @param successCallback
     * @param errorCallback
     * @param displayMessageType
     * @private
     */
    function processText(response, successCallback, errorCallback, finishCallback, displayMessageType) {
        const statusCode = response['status'];
        response.text().then(text => {
            const result = {};
            result['status_code'] = statusCode;
            result['body'] = text;
            if (statusCode === StatusCode.Ok || statusCode === StatusCode.Created) {
                if (successCallback != null) {
                    successCallback(result);
                }
            }
            else if (statusCode === StatusCode.UnAuthorized) {
            }
            else if (statusCode === StatusCode.Forbidden) {
            }
            finishCallback(result);
        });
    }
    /**
     * Jsonが返ってくる場合の処理
     * @param response
     * @param successCallback
     * @param errorCallback
     * @param displayMessageType
     * @private
     */
    function processJson(response, successCallback, errorCallback, finishCallback, displayMessageType) {
        const statusCode = response['status'];
        response.json().then(jsonResponse => {
            const result = {};
            result['status_code'] = statusCode;
            result['body'] = jsonResponse;
            const message = jsonResponse['message'];
            // ステータスコードごとの処理
            if (statusCode === StatusCode.Ok || statusCode === StatusCode.Created) {
                // 成功した場合
                if (displayMessageType === DisplayMessageType.All) {
                    // すべてのメッセージを表示する場合、成功メッセージを表示
                    if (message != null) {
                        if (setting.successMessageAction != null) {
                            setting.successMessageAction(message);
                        }
                    }
                }
                // 成功時の処理を実行する
                successCallback(result);
            }
            else if (statusCode === StatusCode.Forbidden) {
                // 権限がない場合
                setting.responseForbiddenActionFunction();
            }
            else if (statusCode === StatusCode.UnAuthorized) {
                // 認証情報がない場合
                setting.responseUnAuthorizedActionFunction();
            }
            else {
                // その他のエラー
                if (displayMessageType !== DisplayMessageType.None) {
                    // サイレント実行ではない場合、エラーメッセージは表示する
                    if (message != null) {
                        if (setting.errorMessageAction != null) {
                            let description = null;
                            if ('description' in jsonResponse) {
                                description = jsonResponse['description'];
                            }
                            setting.errorMessageAction(message, description, jsonResponse);
                        }
                    }
                }
                // エラー時の処理を実行する
                errorCallback(result);
            }
            // 終了時の処理を実行する
            finishCallback(result);
        });
    }
})(HttpRequestUtil || (HttpRequestUtil = {}));
